import VueRouter from 'vue-router'

import Login from '@/views/Login'
import NotFound from '@/views/404'
import Home from '@/views/Home'

const getView = view => require(`@/views/${view}`).default

let routes = [
  {
    path: '/login',
    component: Login,
    name: 'Login',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
    meta: {
      guests: true
    }
  },
  {
    path: '/',
    component: Home,
    name: 'Home',
    iconCls: 'el-icon-star-on',
    meta: { label: 'Home' },
    redirect: {
      name: 'Dashboard'
    },
    hidden: true
  },
  {
    path: '/dashboard',
    component: Home,
    iconCls: 'el-icon-s-home',
    meta: { label: 'Dashboard' },
    children: [
      {
        path: '',
        component: getView('Dashboard/Dashboard'),
        name: 'Dashboard',
        iconCls: 'el-icon-star-on',
        meta: { label: 'Home' }
      }
    ]
  },
  {
    path: '/pages',
    component: Home,
    iconCls: 'fa fa-desktop',
    meta: { label: 'Podstrony' },
    children: [
      {
        path: '',
        component: getView('Pages/PagesList'),
        name: 'Pages List',
        meta: { label: 'Lista stron' }
      },
      {
        path: 'add',
        component: getView('Pages/PageForm'),
        name: 'Add Page',
        meta: { label: 'Dodaj stronę' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Pages/PageForm'),
        name: 'Edit Page',
        hidden: true,
        meta: { label: 'Edytuj stronę' }
      }
    ]
  },
  {
    path: '/events',
    component: Home,
    iconCls: 'fa fa-calendar',
    meta: { label: 'Wydarzenia' },
    children: [
      {
        path: '',
        component: getView('Events/EventList'),
        name: 'Event List',
        meta: { label: 'Lista wydarzeń' }
      },
      {
        path: 'add',
        component: getView('Events/EventForm'),
        name: 'Add Event',
        meta: { label: 'Dodaj wydarzenie' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Events/EventForm'),
        name: 'Edit Event',
        hidden: true,
        meta: { label: 'Edytuj wydarzenie' }
      }
    ]
  },
  {
    path: '/places',
    component: Home,
    iconCls: 'fa fa-map-marker',
    meta: { label: 'Miejsca' },
    children: [
      {
        path: '',
        component: getView('Places/PlaceList'),
        name: 'Place List',
        meta: { label: 'Lista miejsc' }
      },
      {
        path: 'add',
        component: getView('Places/PlaceForm'),
        name: 'Add Place',
        meta: { label: 'Dodaj miejsce' }
      },
      {
        path: 'cities',
        component: getView('Places/CityList'),
        name: 'City List',
        meta: { label: 'Lista miast' }
      },
      {
        path: 'cities/add',
        component: getView('Places/CityForm'),
        name: 'Add City',
        meta: { label: 'Dodaj miasto' }
      },
      {
        path: 'cities/:id',
        props: true,
        component: getView('Places/CityForm'),
        name: 'Edit City',
        hidden: true,
        meta: { label: 'Edytuj miasto' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Places/PlaceForm'),
        name: 'Edit Place',
        hidden: true,
        meta: { label: 'Edytuj miejsce' }
      }
    ]
  },
  {
    path: '/images',
    component: Home,
    iconCls: 'fa fa-image',
    meta: { label: 'Zdjęcia' },
    children: [
      {
        path: '',
        component: getView('Image/ImageList'),
        name: 'Image List',
        meta: { label: 'Lista zdjęć' }
      },
      {
        path: 'add',
        component: getView('Image/ImageForm'),
        name: 'Add Image',
        meta: { label: 'Dodaj zdjęcie' }
      },
      {
        path: 'catalogs',
        component: getView('Image/CatalogList'),
        name: 'Catalog List',
        meta: { label: 'Lista katalogów' }
      },
      {
        path: 'catalogs/add',
        component: getView('Image/CatalogForm'),
        name: 'Add Catalog',
        meta: { label: 'Dodaj katalog' }
      },
      {
        path: 'catalogs/:id',
        props: true,
        component: getView('Image/CatalogForm'),
        name: 'Edit Catalog',
        hidden: true,
        meta: { label: 'Edytuj katalog' }
      },
      {
        path: ':id',
        props: true,
        component: getView('Image/ImageForm'),
        name: 'Edit Image',
        hidden: true,
        meta: { label: 'Edytuj zdjęcie' }
      }
    ]
  },
  {
    path: '/attachments',
    component: Home,
    iconCls: 'fa fa-download',
    meta: { label: 'Załączniki' },
    children: [
      {
        path: '',
        component: getView('Attachments/AttachmentsList'),
        name: 'Attachments List',
        meta: { label: 'Lista załączników' }
      }
    ]
  },
  {
    path: '/menu',
    component: Home,
    iconCls: 'fa fa-bars',
    meta: { label: 'Menu' },
    children: [
      {
        path: 'main-menu',
        component: getView('Menus/MainMenuForm'),
        name: 'Edit MainMenu',
        meta: { label: 'Edytuj menu główne' }
      },
      {
        path: 'footer-menu',
        component: getView('Menus/FooterMenuForm'),
        name: 'Edit FooterMenu',
        meta: { label: 'Edytuj stopkę' }
      }
    ]
  },
  {
    path: '/users',
    component: Home,
    iconCls: 'fa fa-group',
    meta: { label: 'Użytkownicy' },
    children: [
      {
        path: '',
        component: getView('User/UserList'),
        name: 'User List',
        meta: { label: 'Lista użytkowników' }
      },
      {
        path: 'add',
        component: getView('User/UserForm'),
        name: 'Add User',
        meta: { label: 'Dodaj użytkownika' }
      },
      {
        path: ':id',
        props: true,
        component: getView('User/UserForm'),
        name: 'Edit User',
        hidden: true,
        meta: { label: 'Edytuj użytkownika' }
      }
    ]
  },
  {
    path: '/settings',
    component: Home,
    iconCls: 'fa fa-cog',
    meta: { label: 'Ustawienia' },
    children: [
      {
        path: 'site',
        component: getView('Settings/SettingsForm'),
        name: 'Settings Form',
        meta: { label: 'Konfiguracja strony' }
      },
      {
        path: 'newsletter',
        component: getView('Settings/NewsletterForm'),
        name: 'Newsletter Form',
        meta: { label: 'Konfiguracja newslettera' }
      }
    ]
  },
  {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  const isUserLoggedIn = window.localStorage.getItem('token')
  if (!to.meta.guests && !isUserLoggedIn) {
    next({ name: 'Login', query: { next: to.path } })
    return
  }
  document.title = to.meta.label
    ? `${to.meta.label} - Panel administracyjny`
    : 'Panel administracyjny'
  next()
})

export default router
